/** Sync responses belong to a particular checkpoint, not a globally identified entity. */
const visitSyncCacheKeys = {
  VisitSyncDelta: () => null,
  VisitSyncRevision: () => null,
};

export { visitSyncCacheKeys };
